import { styled } from 'next-yak';

export const DesktopNavContainer = styled.nav`
    display: flex;
    align-items: center;
    justify-content: space-between;

    background-color: var(--grey_50);
    border-bottom: 1px solid var(--grey_200);
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
    padding: 0 var(--layout-padding-side);

    height: 7.2rem;
    width: 100%;
`;

export const NavContact = styled.div``;
